/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/loadingbar"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "HAKAN COPUR",
  title: "Hi, Im Hakan",
  subTitle: emoji(
  "A passionate Gameplay Programmer with a background in C++ software engineering, specializing in multiplayer systems and gameplay mechanics in Unreal Engine 5. I enjoy building interactive experiences that are both technically solid and engaging for players."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/hakancopurr/",
  gmail: "dev@hakancopur.com",
  github: "https://github.com/HakanCopur",
  stackoverflow: "https://stackoverflow.com/users/31176087/hakan",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

  const skillsSection = {
  title: "Skills",
  skills: [
    {
  title: "⚡ Game Development & Engine Tools",
  skillList: emoji("Unreal Engine 5, Blueprints, Animation Blueprint, UMG (UI), Steam API, Multiplayer Replication, Unreal Insights, Profiling Tools, Localization System")
    },
    {
      title: "⚡ Programming Languages",
      skillList: emoji("C++, Python, Blueprint Visual Scripting, MATLAB, C#, Java")
    },
    {
      title: "⚡ Version Control & Development Tools",
      skillList: emoji("Git, GitHub, Visual Studio, JetBrains IDEs")
    },
    {
      title: "⚡ Operating Systems & Other Tools",
      skillList: emoji("Linux, Bash/Shell, Docker, Jira")
    }
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Marmara University",
      logo: require("./assets/images/marmara_logo.png"),
      subHeader: "BS, Electrical and Electronics Engineering",
      duration: "September 2017 - April 2019",
      desc: "GPA: 3.26 / 4.00",
      descBullets: [
        "First Placed In 2242 University Students Research Project Competitions. Certificate ID : 12738860096323",
      ]
    }
  ]
};


const backgroundSection = {
  display: true,
  title: "Background",
  description: `I'm an independent game developer based in Turkey with a background in C++ software engineering and real-time simulation. After working in R&D on V2X communication and autonomous vehicle testing systems, I transitioned into game development to pursue my passion for creating immersive multiplayer experiences. Over the past few years, I’ve designed and built Skyward Steps Together, a complete multiplayer co-op game developed in Unreal Engine 5. This project allowed me to develop everything from gameplay systems and networking to UI, puzzle mechanics, and Steam integration. I enjoy working across disciplines, from technical design and animation to optimization and system architecture, and I take pride in writing modular, scalable Blueprints. While I'm still growing as a developer, I’m dedicated, self-motivated, and experienced in delivering a fully playable, feature-rich game from the ground up.`
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "VeNIT Lab",
      companylogo: require("./assets/images/venitlogo.png"),
      date: "November 2021 – November 2023",
      desc: "Worked as a C++ Software Engineer focused on developing real-time simulation frameworks for V2X communication and autonomous vehicle testing. Collaborated on performance-critical systems designed for hardware-in-the-loop environments.",
      descBullets: [
        "Developed modular simulation components using modern C++",
        "Built tools for testing autonomous driving scenarios and V2X protocols",
        "Contributed to R&D projects involving multi-threading and low-latency data exchange"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  projects: [
    {
      image: require("./assets/images/SkywardStepsAnimatedHeader.mp4"),
      projectName: "Skyward Steps Together",
      projectDesc: "A co-op climbing and parkour game set in a chaotic vertical world.",
      showTrailer: true,
      footerLink: [
        {
          name: "Steam Page",
          url: "https://store.steampowered.com/app/3123610/Skyward_Steps_Together/"
        }
        // you can add extra buttons here.
      ],
      videoUrl: "https://www.youtube.com/embed/kx1tk8Ca0jI?si=xGy9FD0lvHeOMrJU",

      features: [
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_Customization.mp4"),
          alt: "Character Cloth Customization",
          description: "Customize your character in real-time with a modular outfit system. Players can mix and match hats, torsos, pants, and shoes to express their style before the adventure begins."
        },
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_TutorialWidgets.mp4"),
          alt: "InGame Tutorial Widgets",
          description: "Interactive tutorial system with page-by-page guidance, animated text, and embedded gameplay clips to helping players understand mechanics without breaking immersion."
        },
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_InGameSaveLoadSystem.mp4"),
          alt: "Save Load System",
          description: "Developed a robust in-game save/load system that persistently stores not only player position but also dynamic world states, including puzzle progress, triggered events, and environmental changes with ensuring seamless session continuity."
        },

        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_RadialMenuAndSkills.mp4"),
          alt: "Skill selection via radial menu and abilities",
          description: "Designed and implemented a modular skill system with an intuitive radial menu for in-game selection. Each skill, including portal creation, bridge construction, and super jump, is integrated with its own in-world control widget that allows players to interactively place and activate abilities. The system is built with multiplayer compatibility and supports smooth input handling for responsive and flexible co-op gameplay."
        },

        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_ModularInteractionSystem.mp4"),
          alt: "Multiplayer interaction system with puzzles and objects",
          description: "Developed a flexible interaction system designed for multiplayer gameplay, allowing players to interact with a wide range of world objects including pushable stones, sliding puzzles, switches, and cannons. The system is built using interfaces and component-based logic to ensure scalability and seamless replication across networked clients."
        },

        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_SteamIntegratedLeaderBoard.mp4"),
          alt: "Steam leaderboard shown in menu and game world",
          description: "Implemented a fully Steam-integrated leaderboard system written in C++ for real-time score tracking and display. The leaderboard can be viewed through a start menu widget or as a physical in-world display blueprint with custom decorations, providing both functional and immersive score presentation. Designed for multiplayer compatibility with optimized data retrieval from the Steam API."
        },

        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_SomeOfPuzzles.mp4"),
          alt: "Some Of Modular Puzzle Mechanics",
          description: "Designed and implemented a diverse set of interactive puzzles with full multiplayer replication support. The system includes both modular and handcrafted puzzle logic, featuring mechanics such as rotating dial alignment, sliding image reconstruction, antenna-based electricity routing, laser mirror redirection, dynamic water pipe flow control, and musical sequence detection. Each puzzle is built with scalability in mind, allowing seamless integration into gameplay flow while encouraging exploration, logic, and cooperation."
        },
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_LobbySystem.mp4"),
          alt: "Lobby System",
          description: "Built a multiplayer lobby system with full Steam integration, supporting friend invites, session discovery, and seamless travel to gameplay maps. Designed using Unreal Engine's session management framework with Advanced Sessions plugin and custom Blueprint logic to handle host authority, player readiness, and travel transitions while preserving game state."
        },
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_Localization.mp4"),
          alt: "Localization",
          description: "Implemented a dynamic settings menu with full localization support for 9 languages. The system leverages Unreal Engine's string tables and font fallback configuration to apply translations in real-time without requiring a restart. Built with scalability in mind to support future language expansion and ensure UI compatibility across diverse character sets."
        }
        ,
        {
          url: require("./assets/images/SkywardStepsTogether/Portfolio_Optimizations.png"),
          alt: "Optimization",
          description: "Applied a range of performance optimizations including LOD setup, texture resolution control, distance-based mesh culling, and CPU-side activation using overlap volumes. Used Unreal Insights to analyze and reduce game thread overhead by disabling unnecessary ticks, optimizing actor/component lifecycles, and streamlining animation updates. Also prototyped a data layer streaming system to minimize RAM usage, later removed after reaching acceptable memory performance."
        }


      ]

    },
    {
  image: require("./assets/images/SteamSAL/SteamSAL_Header.jpg"), // ← replace with one of your 3 images
  projectName: "Steam Achievements & Leaderboards Plugin",
  projectDesc:
    "Unreal Engine plugin providing easy Blueprint + C++ access to Steam achievements, stats, and leaderboards. Includes async nodes, cached reads, and multiplayer-safe workflows.",
  showTrailer: false, // no trailer block for this project

  footerLink: [
    {
      name: "Fab Marketplace",
      url: "https://www.fab.com/listings/2cf94d29-c41d-4be5-bdb4-377122a92d8d"
    },
    {
      name: "Documentation",
      url: "https://hakancopur.com/SteamSAL-docs"
    }
    // { name: "GitHub", url: "https://github.com/..." } // optional
  ],

  // Use your 3 photos here (PNG/JPG/MP4 also fine).
  // Each item shows as a feature block with media + description.
  features: [
    {
  url: require("./assets/images/SteamSAL/SteamSAL_Leaderboards.jpg"),
  alt: "Complete Steam Leaderboard Node Set",
  description:
    "Comprehensive set of Blueprint nodes for Steam Leaderboards. Includes functions for creating, finding, and uploading scores, downloading global or user entries, and breaking detailed entry data. Designed for seamless integration into any Unreal Engine project without requiring C++ setup."
  },
  {
    url: require("./assets/images/SteamSAL/SteamSAL_Achievements.jpg"),
    alt: "Easy Achievements and Player Stats Nodes",
    description:
      "Full Blueprint interface for Steam Achievements and Player Stats management. Supports unlocking, progress tracking, global stats queries, and local stat caching. Built for simplicity. Developers can handle complex Steam API features through a single visual workflow."
  }
  ]
},
  ],
  display: true // Set false to hide this section, defaults to true
};


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: false, // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  backgroundSection 
};
